/* eslint-disable react/jsx-filename-extension */
import React, {
  createContext, useState, useCallback,
} from 'react';
import Image from 'next/image';
import toastImage from '../../public/assets/toast.png';

export const ToastContext = createContext();

// eslint-disable-next-line react/prop-types
export function ToastContextProvider({ children }) {
  const [toast, setToast] = useState(null);
  const [visible, setVisible] = useState(false);
  const [onClick, setOnClick] = useState(null);
  const [position, setPosition] = useState('center');

  const showToast = useCallback((text, duration = 3000, options = {}) => {
    setToast(text);
    setVisible(true);
    setOnClick(() => options.onClick || null);
    setPosition(options.position || 'center');
    setTimeout(() => {
      setVisible(false);
      setOnClick(null);
      setPosition('center');
    }, duration);
  }, []);

  const getPositionClasses = () => {
    if (position === 'bottom-right') {
      return 'bottom-20 right-4 lg:bottom-24 lg:right-8';
    }
    return 'bottom-20 left-1/2 transform -translate-x-1/2 lg:bottom-24';
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
      setVisible(false);
    }
  };

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {visible && toast && (
        <div
          className={`fixed bg-greyBlack text-white px-4 py-2 rounded shadow-lg flex items-center space-x-5 z-[9999] slideup-animation w-full max-w-md ${getPositionClasses()} ${onClick ? 'cursor-pointer hover:bg-gray-800' : ''}`}
          onClick={handleClick}
          role={onClick ? 'button' : undefined}
          // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
          tabIndex={onClick ? 0 : undefined}
          onKeyPress={(e) => {
            if (onClick && (e.key === 'Enter' || e.key === ' ')) {
              handleClick();
            }
          }}
        >
          <div className="bg-gray-700 text-white p-2 rounded-full flex items-center justify-center w-11">
            <Image width={500} height={500} src={toastImage} alt="toast-icon" />
          </div>
          <span>{toast}</span>
        </div>
      )}
    </ToastContext.Provider>
  );
}

// export function useToast() {
//   return useContext(ToastContext);
// }
